import CryptoJS from 'crypto-js';

/**
 * 解密响应数据
 * @param encryptedBase64 - Base64 编码的加密数据
 * @param serverSeed - 服务端返回的签名种子
 * @param timestamp - 请求时的时间戳（毫秒级）
 * @returns 解密后的 JSON 对象
 */
export function decryptResponse(encryptedBase64: string, serverSeed: string, timestamp: number): any {
  console.log('Decrypting response with timestamp:', timestamp);
  // 1. 计算时间窗口和 FinalSalt（与签名逻辑一致）
  const timeSlot = Math.floor(timestamp / 60000);
  const finalSalt = CryptoJS.SHA256(serverSeed + timeSlot).toString(CryptoJS.enc.Hex);

  // 2. 提取 AES Key (FinalSalt 的前16个字符)
  const keyString = finalSalt.substring(0, 16);
  const key = CryptoJS.enc.Utf8.parse(keyString);

  // 3. AES 解密 (ECB 模式, PKCS7 填充)
  const decryptedParams = {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  };

  const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, decryptedParams);

  // 4. 转为 JSON
  const jsonString = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(jsonString);
}
